<template>
  <!-- 班级主页 -->
   <div class="my-homepage">
    <div class="head">
      <div class="select-div-top">
        <form action="/" class="logo-container">
          <img src="@/assets/images/grade/go-home.png" v-if="isBackGradeList" class="return-list" @click="handleGo('gradelist')" alt="">
          <van-search v-model="searchContent" right-icon="" shape="round" :class="isBackGradeList?'':'w100'"
          placeholder="搜索内容" @search="onCourseSearchEnter"
          :clearable="true" clear-trigger="always" @clear="clearSearchValue">
          <template #left-icon>
              <van-icon name="search" />
          </template>
          </van-search>
        </form>
      </div>
      <div class="head-main" :class="headCompute && headCompute.className && headCompute.className.length>16?'':'head-main-one'">
        <img src="../../assets/images/grade/grade-logo.png" alt="" class="logo"/>
        <div class="main-right" >
          <p class="right-title">{{headCompute.className}}</p>
          <div class="right-num">
            <p class="num"><span class="span-num">{{ headCompute.userNum }}</span>成员</p>
            <i class="icon-hen"></i>
            <p class="num"><span class="span-num">{{ headCompute.postbarNum }}</span>发帖量</p>
          </div>
          <p class="right-desc">本专区的讨论仅限于心电生理产品的特征和功能，请勿就任何情况或个人提供的诊断，治疗，建议和观点</p>
        </div>
      </div>
    </div>
    <div class="page-main">
      <div class="sec-flex">
        <div :class="['flex-txt', active === item.code ? 'cur' : '']" v-for="item in filterTabList" :key="item.code"
          @click="handleMenuCheck(item)" v-track="{ functionName: `专区-${item.name}` }">
          <span class="txt">{{ item.name }}</span>
          <img v-show="item.code === active" src="@/assets/images/grade/img2.png" class="icon1" alt="" />
        </div>
      </div>
      <!-- 班级主页 -->
      <div class="fixed-btn" v-if="isAddBBS">
        <img src="@/assets/images/grade/add-homepage.png" @click="showDialog = true" class="img-btn" alt="" />
      </div>
      <div class="main-box">
        <gradeHomeList ref="gradeHome" :commonPer="commonPer" :isAdminPermiss="isAdminPermiss"  :classId="classId" v-if="active === 1"></gradeHomeList>
        <gradeDate ref="gradeDate" :classId="classId" v-if="active === 2"></gradeDate>
        <StudentList ref="studentList" :classId="classId" v-if="active === 3" />
        <journeyPage :classId="classId" :isAdminPermiss="isAdminPermiss" v-if="active === 4"></journeyPage>
        <gradeIEPList ref="gradeIEP" :isAdminPermiss="isAdminPermiss" :commonPer="commonPer" :classId="classId" v-if="active === 5"></gradeIEPList>
        <gradeAnswerList ref="gradeAnswer" :isAdminPermiss="isAdminPermiss" :commonPer="commonPer" :classId="classId" v-if="active === 6"></gradeAnswerList>
        <Ranking ref="ranking" :classId="classId" v-if="active === 7" />
      </div>
    </div>

    <div class="fixed-dialog" v-if="showDialog">
      <div class="dialog-bg" @click="showDialog = false"></div>
      <div class="dialog-con">
        <div class="con-top">
          <img :src="userInfo.headPicUrl" class="top-cover" alt="" />
          <div class="top-txt">{{ userInfo.realName }}</div>
          <div class="top-close" @click="showDialog = false">取消</div>
        </div>
        <div class="content-div">
          <div class="div-block" @click="handleGo('addpost')">
            <img src="@/assets/images/grade/icon-bbs.png" class="div-icon" alt="" />
            <div class="div-txt">帖子</div>
          </div>
          <template v-if="isAdminPermiss">
            <div class="div-block"  @click="handleGo('addIep')">
              <img src="@/assets/images/grade/icon-iep.png" class="div-icon" alt="" />
              <div class="div-txt">iEP学习</div>
            </div>
            <div class="div-block"  @click="handleGo('addMock')">
              <img src="@/assets/images/grade/simulator.png" class="div-icon" alt="" />
              <div class="div-txt">模拟器练习</div>
            </div>
            <div class="div-block" @click="handleGo('addAnswer')">
              <img src="@/assets/images/grade/icon-answer.png" class="div-icon" alt="" />
              <div class="div-txt">线上答疑</div>
            </div>
            <div class="div-block" @click="handleGo('addExamine')">
              <img src="@/assets/images/grade/icon-examine.png" class="div-icon" alt="" />
              <div class="div-txt">考试</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="delModel" v-if="isModel">
      <div class="model-dissolve">
        <p class="delModel-head">提示</p>
        <p class="title">{{ message }}</p>
      </div>
    </div>
   </div>
</template>

<script>
import { tabList, rolesClick } from './data'
import { classUserPermissions, joinClassRoom, classroomCompute } from '@/api/grade'
import gradeHomeList from './components/homeList.vue'
import StudentList from './components/studentList.vue'
import Ranking from './components/ranking.vue'
import gradeDate from './components/date.vue'
import journeyPage from './components/journeyPage.vue'
import gradeIEPList from './components/gradeIEPList.vue'
import gradeAnswerList from './components/gradeAnswerList.vue'
import {Toast, Dialog} from 'vant'
import withRouteTracking from '@/utils/withRouteTracking'
// import {PEROLES, CDROLES} from '@/utils/configRoles.js'
import { getShareInfo } from '@/utils/wxShare'
import {handleTraceSearchLog} from '../../utils/trace'
const UserProfile = {
  components: {
    gradeHomeList,
    StudentList,
    gradeDate,
    journeyPage,
    gradeIEPList,
    gradeAnswerList,
    Ranking
  },
  data() {
    return {
      classId: '',
      isModel: false,
      areaId: '',
      headCompute: {},
      showDialog: false,
      roles: {},
      searchContent: '',
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      load: false,
      tabList,
      active: 1,
      isAddBBS: false, // 是否可以发帖
      roleType: 0,
      isAdminPermiss: false, // 超管，管理员权限
      commonPer: false, // 普通员工 发普通帖子，点赞评论
      isCommonRead: false, // 只读权限
      // userList: [...PEROLES, ...CDROLES],
      // userPerssList: CDROLES,
      userPerss: '', // 权限字段
      isUserPerss: false, // 用户权限
      isJourneyEdit: false, // 编辑课程
    }
  },
  async created() {
    this.classId = this.$route.query.classId
    this.areaId = this.$route.query.areaId
    if (this.classId) {
      this.handleShareMethod()
      this.getClassUserPermissions()
      await this.handleClassroomCompute()
    }
    this.userPerss = JSON.parse(sessionStorage.getItem('gradeUserPermissions'))
    this.isUserPerss = true// this.userPerssList.includes(this.userPerss)
    sessionStorage.removeItem('selectCourse')
    localStorage.removeItem('changeAboutCon')
    localStorage.removeItem('addMockCon')
    sessionStorage.removeItem('addGradeExamine')
    sessionStorage.removeItem('changeCourseCon')
    sessionStorage.removeItem('addExmine')
    this.roles = JSON.parse(sessionStorage.getItem('roleResult'))
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    filterTabList() {
      return this.tabList.filter(acc => {
        if (!this.isAdminPermiss && acc.code === 2) {
          return false
        } else {
          return acc
        }
      })
    },
    isBackGradeList () {
      return this.userList.includes(this.userPerss) || JSON.parse(sessionStorage.getItem('isWhiteUser'))
    },
    ADMINROLES() {
      return JSON.parse(`${sessionStorage.getItem('gradeRolesList')}`).ADMINROLES
    },
    EDITORROLES() {
      return JSON.parse(`${sessionStorage.getItem('gradeRolesList')}`).EDITORROLES
    },
    userList() {
      return [...this.ADMINROLES, ...this.EDITORROLES]
    }
  },
  mounted() {
    if (sessionStorage.getItem('changeGradeTabActive')) {
      this.active = Number(sessionStorage.getItem('changeGradeTabActive'))
    }
  },
  methods: {
    handleShareMethod() {
      window.sessionStorage.setItem('mainId', this.classId)
      window.sessionStorage.setItem('serviceId', this.classId)
      let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : ''
      window.sessionStorage.setItem('entrance', entrance)
      getShareInfo({
        title: 'iEP-中国电生理术者充电站',
        titleTimeLine: 'iEP-中国电生理术者充电站',
        desc: '更智慧、更全面、更懂你。',
        link: window.location.href,
        linkTimeLine: window.location.href,
        images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
      })
    },
    // 班级信息
    handleClassroomCompute() {
      const params = {
        classId: this.classId
      }
      classroomCompute(params).then(res => {
        this.headCompute = res.data
        window.sessionStorage.setItem('mainId', res.data.id)
        this.$forceUpdate()
      })
    },
    handleMenuCheck(item) {
      this.active = item.code
      if (`${this.active}` !== '1') {
        this.searchContent = ''
      }
      sessionStorage.setItem('changeGradeTabActive', this.active)
    },
    // 发帖操作
    handleGo (type) {
      localStorage.removeItem('addMockCon')
      localStorage.removeItem('changeAboutCon')
      localStorage.removeItem('addIEPCon')
      let path = ''
      switch (type) {
        case 'addpost': // 帖子
          if (rolesClick(this.roles, this.userInfo)) return
          path = `/addGradePost?areaId=${this.classId}`
          break
        case 'gradelist':
          path = `/grade`
          break
        case 'addMock': // 模拟器
          if (rolesClick(this.roles, this.userInfo)) return
          path = `/gradeMock?areaId=${this.classId}`
          break
        case 'addAnswer': // 线上答疑
          if (rolesClick(this.roles, this.userInfo)) return
          path = `/gradeAnswer?areaId=${this.classId}`
          break
        case 'addIep': // iep学习
          if (rolesClick(this.roles, this.userInfo)) return
          path = `/gradeIep?areaId=${this.classId}`
          break
        case 'addExamine': // iep班级考试
          if (rolesClick(this.roles, this.userInfo)) return
          sessionStorage.removeItem('changeCourseCon')
          path = `/gradeExamine?classId=${this.classId}`
          break
        default:
          break
      }
      this.$router.push({
        path
      })
    },
    handleMsg() {
      this.message = '暂无班级权限，已为您跳转至iEP首页。'
      this.isModel = true
      this.settime = setTimeout(() => {
        this.$router.push({
          path: '/home'
        })
      }, 3000)
    },
    // 获取用户班级角色权限
    getClassUserPermissions() {
      const params = {
        classId: this.classId,
        userId: this.userInfo.id
      }
      classUserPermissions(params).then(res => {
        const data = res.data
        this.roleType = data.roleType
        // roleType: 1 班级超管 2 班级管理员 3班级学员
        if (this.userInfo.memberType === 1) { // 员工
          if (!data.inClassList) {
            if (this.isUserPerss && data.isManage) { // CS CD 只能更改班级课程，帖子查看，没有发帖按钮
              this.isJourneyEdit = true // 编辑课程
            } else { // 只读
              // this.isCommonRead = true
            }
          } else { // 所有操作都可以
            if ([1, 2].includes(data.roleType)) { // 超管，管理员可以发帖
              this.isAddBBS = true
              this.isAdminPermiss = true
              this.isJourneyEdit = true
            }
          }
        } else { // 术者
          if (data.inClassList && data.userStatus === 1 && data.roleType === 3) {
            // 已加入 && 员工 -> 发普通帖子，点赞评论，可以确认帖子
            this.isAddBBS = true
            this.commonPer = true
          } else if (data.userStatus === 2) { // 不在邀请名单内
            this.handleDialog(data)
            // this.handleMsg()
          }
        }
      })
    },
    handleDialog(data) {
      Dialog.confirm({
        title: '提示',
        message: `您已被邀请到${data.className}班级，但还没加入是否需要加入！`,
        confirmButtonText: '加入',
        cancelButtonText: '回首页',
        className: 'default-confirm-dialog'
      }).then(() => {
        const params = {
          classId: data.classId,
          userId: this.userInfo.id
        }
        joinClassRoom(params).then(res => {
          if (res.code === 0) {
            Toast('您已加入班级')
            this.active = 1
            this.getClassUserPermissions()
            sessionStorage.setItem('changeGradeTabActive', this.active)
          }
        })
      }).catch(() => {
        this.settime = setTimeout(() => {
          this.$router.push({
            path: '/home'
          })
        }, 1500)
      })
    },
    clearSearchValue () {
      this.$refs.gradeHome.searchContent = ''
      this.$refs.gradeHome.pageObj.pageNo = 1
      this.$refs.gradeHome.pageObj.pageSize = 10
      this.$refs.gradeHome.loading = false
      this.$refs.gradeHome.finished = false
      this.$refs.gradeHome.finishText = '没有更多了'
      this.$refs.gradeHome.list = []
      this.$refs.gradeHome.handleGetPostList()
    },
    onCourseSearchEnter () {
      if (this.active === 1) {
        this.$refs.gradeHome.searchContent = this.searchContent
        this.$refs.gradeHome.pageObj.pageNo = 1
        this.$refs.gradeHome.pageObj.pageSize = 10
        this.$refs.gradeHome.loading = false
        this.$refs.gradeHome.finished = true
        this.$refs.gradeHome.finishText = '没有更多了'
        this.$refs.gradeHome.list = []
        handleTraceSearchLog({
          'userId': this.userInfo.id,
          'searchContent': this.searchContent,
          'sessionId': localStorage.getItem('sessionId'),
          'type': 11,
          'entrance': 55,
        })
        this.$refs.gradeHome.handleGetPostList()
      }
    }
  }
}
export default withRouteTracking(UserProfile)

</script>

<style scoped lang="less">
.my-homepage{
  position: relative;
  background: #F9F8F7;
  box-sizing: border-box;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  .head{
    position: relative;
    display: flex;
    height: 168px;
    flex-direction: column;
    .select-div-top{
      position: relative;
    }
    .aifv-div-top {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      width: 100%;
      height: 70px;
    }
    .logo-container {
      display: flex;
      align-items: center;
      width: 100%;
      position: relative;
      z-index: 2;
      padding: 0 !important;
      margin: 0 !important;
      justify-content: center;
      .return-list {
        width: 95px;
        height: 40px;
        display: block;
      }
      /deep/ .van-search {
        background-color: transparent;
        padding-right: 0!important;
        padding-left: 8px!important;
        width: 240px;
        width: calc(100% - 115px);
        .van-search__content {
          background: #fff;

          .van-field__control {
            color: #949BA5;
            font-weight: 400;
            font-size: 13px;
            &::placeholder {
              color: #949BA5;
              font-weight: 400;
              font-size: 13px;
            }
          }
        }
      }
      .w100 {
        padding-left: 10px!important;
        padding-right: 10px!important;
        width: 100% !important;
        /deep/ .van-search {
          width: 100% !important;
        }
      }
    }
    .head-main{
      margin:0 10px;
      background: #fff;
      height: 96px;
      padding:10px 10px 10px 16px;
      box-sizing: border-box;
      position: relative;
      display: flex;
      position: relative;
      border-radius: 20px;
      z-index: 2;
      .logo{
        width: 42px;
        height: 47px;
        margin-right: 14px;
      }
      .main-right{
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        .right-title{
          font-weight: 600;
          font-size: 14px;
          color: #202020;
          line-height: 18px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .right-num{
          display: flex;
          .num{
            font-weight: 400;
            font-size: 12px;
            color: #564C47;
            line-height: 20px;
            .span-num{
              font-weight: bold;
              font-size: 16px;
              color: #564C47;
              margin-right: 3px;
            }
          }
          .icon-hen{
            width: 1px;
            height: 14px;
            position: relative;
            top: 4px;
            margin:0 16px;
            background: #C1BBB3;
          }
        }
        .right-desc{
          font-weight: 500;
          font-size: 8px;
          color: #757E90;
          line-height: 10px;
        }
      }

    }
    .head-main-one{
      padding:16px 10px 10px 16px;
      .right-title{
        font-size: 18px;
        line-height: 20px;
      }
      .right-num{
        margin-top: 2px;
      }
      .right-desc{
        margin-top: 2px;
      }
    }
  }
  .page-main{
    position: relative;
    top: 8px;
    z-index: 3;
    background-color: #FFF;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    position: relative;
    width: 100%;
    height: calc(100% - 100px);
    flex-direction: column;
    overflow-y: hidden;
    .sec-flex {
      display: flex;
      justify-content: space-between;
      padding: 0 16px;
      box-sizing: border-box;
      height: 42px;
      align-items: center;
      border-radius: 12px 12px 0 0;

      .flex-txt {
        position: relative;
        height: 42px;
        line-height: 42px;
        font-size: 14px;
        color: #656e7f;
        font-weight: 500;

        &:nth-last-child(1) {
          margin-right: 0;
        }

        &.cur {
          font-weight: 600;
          color: #EB1700;
        }

        .txt {
          white-space: nowrap;
        }

        .icon1 {
          position: absolute;
          width: 23px;
          bottom: 4px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    .main-box{
      flex: 1;
      overflow-y: scroll;
      height: calc(100% - 42px);
    }
  }
}
.img-btn {
  position: fixed;
  width: 50px;
  height: 50px;
  right: 6px;
  bottom: 100px;
  z-index: 9;
}
.fixed-dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;

  .dialog-bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 0;
    top: 0;
  }

  .dialog-con {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-bottom: 10px;
    box-sizing: border-box;
    background-color: #f2f7fa;

    .con-top {
      display: flex;
      align-items: center;
      padding: 0 10px;
      height: 58px;

      .top-cover {
        width: 32px;
        height: 32px;
        margin-right: 5px;
        border-radius: 50%;
        display: block;
      }

      .top-txt {
        flex: 1;
        font-size: 14px;
        color: #000000;
      }

      .top-close {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
      }
    }

    .content-div {
      display: flex;
      padding-left: 10px;
      box-sizing: border-box;
      flex-wrap: wrap;

      .div-block {
        margin-right: 6px;
        background-color: #fff;
        border-radius: 17px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 84px;
        height: 80px;
        margin-bottom: 8px;

        &:nth-last-child(1) {
          margin-right: 0;
        }

        .div-icon {
          width: 32px;
          height: 32px;
          margin-bottom: 2px;
        }

        .div-txt {
          line-height: 20px;
          font-size: 12px;
          color: #495266;
          text-align: center;
        }
      }
    }
  }

}
.delModel {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 26px;

  .model-dissolve {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -160px;
    margin-top: -98px;
    background: url("../../assets/images/grade/model-bg.png") no-repeat center center / 100% 100%;
    width: 320px;
    height: 195px;
    padding: 15px 17px 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .delModel-head {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 600;
      font-size: 17px;
      color: #000000;
      line-height: 20px;
      margin-bottom: 20px;
      text-align: center;
    }

    .title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.8);
      line-height: 26px;
      margin: 20px 50px;
      text-align: center;
      flex: 1;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/homePage.vue